import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes 
} from "react-router-dom";

import { Navegacion } from "./components/Navegacion";
import { Footer } from "./components/Footer";
import { Inicio } from "./components/Inicio";
import { Efrst } from "./components/Efrst";
import { Contactanos } from "./components/Contactanos";
import { AuthProvider} from "./context/AuthContext";




/* PROTEGER PANEL */


export const App = () => {

  return (

    <AuthProvider>

      <Router>

        <div className="app-layout">


          <Navegacion />


          <Routes>

            <Route
              path="/"
              element={<Inicio />}
            />

           
            <Route
              path="/efrst"
              element={<Efrst />}
            />

           
           

            <Route
              path="/contacto"
              element={<Contactanos />}
            />

                  

          </Routes>


          <Footer />


        </div>

      </Router>

    </AuthProvider>

  );

};

export default App;